import { Button, Tooltip } from "@mui/material";
import React from "react";

export default function ActionButton({ color, children, onClick, title = "add" }) {
  const commonStyles = {
    minWidth: 0,
    margin: "4px", 
    boxSizing: "border-box",
    border: "1px solid #CCC",
  };

  const colorStyles = {
    primary: {
      backgroundColor: "#F1F1F1",
      color: "#000",
      "&:hover": {
        borderColor: "#FF6A00",
        color: "#FF6A00",
        backgroundColor: "#F1F1F1",
      },
    },
    secondary: {
      backgroundColor: "red",
      color: "#FFF",
      "&:hover": {
        backgroundColor: "#d32f2f",
        color: "#FFF",
      },
    },
  };

  return (
    <Tooltip title={title} aria-label={title}>
      <Button
        onClick={onClick}
        sx={{
          ...commonStyles,
          ...(colorStyles[color] || {}),
        }}
      >
        {children}
      </Button>
    </Tooltip>
  );
}
